module.exports = __webpack_public_path__ + "static/media/red-bg@1.5x.9b90a5f6.png";